class SectionHorizontalImageText implements ng.IComponentController {
    ltTitle: string;
    text: string;
    ImageUrl: string;
    buttons: anm.LandingButtonData[];
}

angular.module('animatronApp.sectionHorizontalImageText', []).component('sectionHorizontalImageText', {
    bindings: {
        ltTitle: '<',
        text: '<',
        buttons: '<',
        imageUrl: '<',
    },
    controller: SectionHorizontalImageText,
    templateUrl: require('landing-template/components/sections/section-horizontal-image-text.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/sections/SectionHorizontalImageText.ts